import { CircularProgress } from '@mui/material';
import clsx from 'clsx';
import MaterialTextField from 'src/components/material/textField';
import featureStyles from '../../RegisterModalShared.module.scss';

export interface FirstStepProps {
  error: string;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  handleSendCode: (event: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
  goToLogin: () => void;
}

export const FirstStep: React.FC<FirstStepProps> = ({
  error,
  phoneNumber,
  setPhoneNumber,
  handleSendCode,
  loading,
  goToLogin,
}) => {
  return (
    <section className={featureStyles.content}>
      <h1 className={featureStyles.title}>Reset Password</h1>

      <form onSubmit={handleSendCode} className={featureStyles.form} noValidate>
        <span>
          <MaterialTextField
            id="phone-number"
            name="phoneNumber"
            label="Phone Number"
            value={phoneNumber}
            color="primary"
            variant="outlined"
            isPhoneNumber
            helperText={error}
            error={!!error}
            onChange={(event) => setPhoneNumber(event.target.value)}
          />
        </span>

        <button
          type="submit"
          className={clsx(
            featureStyles.button,
            featureStyles['button--primary']
          )}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress sx={{ color: '#fff' }} size={28} thickness={4} />
          ) : (
            'Send Code'
          )}
        </button>
      </form>

      <div className={featureStyles.footer}>
        Remember your password?
        <button
          className={clsx(
            featureStyles.link,
            featureStyles['link__button'],
            featureStyles['link--primary']
          )}
          onClick={goToLogin}
        >
          Login
        </button>
      </div>
    </section>
  );
};
